import {Spinner} from "@telegram-apps/telegram-ui";

export const FullScreenLoader = () => {
  return (
    <div className="absolute w-full h-full flex items-center justify-center">
      <Spinner size={"l"}/>
    </div>
  );
}
